
        import React from 'react';
        import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new SpriteSymbol({
  "id": "info.sprite",
  "use": "info.sprite-usage",
  "viewBox": "0 0 56 56",
  "content": "<symbol viewBox=\"0 0 56 56\" xmlns=\"http://www.w3.org/2000/svg\" id=\"info.sprite\">\n <path d=\"m25.67 39.67h4.667v-14h-4.667zm2.333-35c-12.88 0-23.33 10.45-23.33 23.33s10.45 23.33 23.33 23.33 23.33-10.45 23.33-23.33-10.45-23.33-23.33-23.33zm0 42c-10.29 0-18.67-8.377-18.67-18.67s8.377-18.67 18.67-18.67 18.67 8.377 18.67 18.67-8.377 18.67-18.67 18.67zm-2.333-25.67h4.667v-4.667h-4.667z\" fill-rule=\"evenodd\" />\n</symbol>"
});
        sprite.add(symbol);

        const InfoSpriteSpriteSymbol = props => (
            <svg {...props} viewBox='0 0 56 56'>
                <use xlinkHref='#info.sprite' />
            </svg>
        );
        export default InfoSpriteSpriteSymbol;
  